import { render, staticRenderFns } from "./StartApp.vue?vue&type=template&id=1647a9d7&scoped=true&"
import script from "./StartApp.vue?vue&type=script&lang=ts&"
export * from "./StartApp.vue?vue&type=script&lang=ts&"
import style0 from "./StartApp.vue?vue&type=style&index=0&id=1647a9d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1647a9d7",
  null
  
)

export default component.exports